// Imports
var ___CSS_LOADER_API_IMPORT___ = require("../../../node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(false);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".collection-container[data-v-fb582ae6]:before{content:\"\";display:block;background-color:#000;height:1px;width:100%}", ""]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___;
